<script lang="ts" setup>
import { VThemeToggle, useThemeStore, type ThemeMode } from "@app/core";
import { onMounted } from "vue";

const { compact = false } = defineProps<{
  /** Compact mode — icon-only width, for the collapsed sidebar */
  compact?: boolean
}>();

const themeStore = useThemeStore();

// setThemeMode, not a v-model write: it also stamps `data-theme` on the
// document and persists the choice.
const handleThemeChange = (newMode: ThemeMode): void => {
  themeStore.setThemeMode(newMode);
};

onMounted(() => {
  themeStore.initTheme();
});
</script>

<template>
  <VThemeToggle
    :compact
    :model-value="themeStore.themeMode"
    @update:model-value="handleThemeChange"
  />
</template>
